<div mat-dialog-content class="relative no_max_height" [ngSwitch]="selectedIndex">
	<ng-container *ngFor="let i of images; let index=index;">
		<ng-container *ngSwitchCase="index">
			<img [src]="i">
		</ng-container>
	</ng-container>
</div>

<button mat-fab *ngIf="selectedIndex > 0 && showButtons" class="left bg_white_high_emphasis" @fadeInOut (click)="selectedIndex = selectedIndex-1;">
	<mat-icon class="color_black_high_emphasis">chevron_left</mat-icon>
</button>
<button mat-fab *ngIf="selectedIndex < images.length-1 && showButtons" @fadeInOut class="right bg_white_high_emphasis" (click)="selectedIndex = selectedIndex+1;">
	<mat-icon class="color_black_high_emphasis">chevron_right</mat-icon>
</button>